import React from 'react';
import Classnames from 'classnames';

export default ({ value, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 51 48"
    onClick={onClick}
    className={Classnames('favorite', { active: !!value })}
  >
    <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/History/Favorite.js